<template>
  <div class="">
    <a-table
      size="middle"
      :columns="columns"
      :data-source="tableData"
      :loading="loading"
      :row-key="(record, index) => record.id"
      bordered
      :pagination="false"
      :locale="{ emptyText: '暂无数据' }"
    >
      <template slot="sort" slot-scope="text, record, index">
        {{ index + 1 }}
      </template>
      <template slot="name" slot-scope="text, record">
        <span v-if="record.required" class="text-color-orange">*</span>
        {{ text }}
      </template>
      <template slot="remark" slot-scope="text, record">
        {{ text }}
        <a class="remark-a" v-if="record.template" @click="downloadFile(record.template)">
          模板下载
        </a>
      </template>
      <template slot="oper" slot-scope="text, record">
        <fileUpload
          className="fnc-file"
          :hideButtonHasFiles="true"
          name="file"
          :disabled="readonly"
          :showList="record.showList"
        />
      </template>
    </a-table>
    <div class="text-color-orange" style="margin-top:16px;">
      <div v-for="(remark, index) in bankFilingRemark" :key="index" :style="index > 0 ? 'padding-left:29px': ''">
        <span v-if="index==0">注：</span>{{index + 1}}、{{remark}}
      </div>
    </div>
  </div>
</template>

<script>
import { fileQueryAPI } from "@/api/file.js";

export default {
  props: {
    params: {
      type: Object
    },
    readonly: {
      type: Boolean
    }
  },
  components: {},
  data() {
    return {
      loading: false,
      tableData: [],
      columns: [
        {
          title: "序号",
          dataIndex: "sort",
          scopedSlots: { customRender: "sort" }
        },
        {
          title: "文件名称",
          dataIndex: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "相关说明",
          dataIndex: "remark",
          scopedSlots: { customRender: "remark" }
        },
        {
          title: "操作",
          dataIndex: "oper",
          width: "300px",
          scopedSlots: { customRender: "oper" }
        }
      ],
      cstId: this.$store.getters["home/getUserObj"].cstIds[0] || ""
    };
  },
  computed: {
    tblBlId(){
      return this.cstId + "_" + this.$route.query.bankCd
    },
    bankFilingRemark(){
      return this.dict.bankFilingRemark[this.$route.query.bankCd] || []
    }
  },
  methods: {
    initData() {
      let bankCd = this.$route.query.bankCd;
      this.tableData = this.dict.bankFilingFileList[this.dict.bankListMap[bankCd]] || this.dict.bankFilingFileList[this.dict.bankListMap["beijing"]];
      this.queryFile();
    },
    queryFile(){
      this.loading = true;
      fileQueryAPI({tblBlId: this.tblBlId, fileTpCd: '5'}).then(res => {
        let resData = res.data || [];
        resData.forEach((file) => {
          this.tableData.forEach((item,idx) => {
            if(item.id == file.fileSubTpCd){
              this.tableData[idx].showList = [file];
              return;
            }
          })
        });
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    downloadFile(template){
      // window.open(template.url);
      this.utils.queryTemplateFile(template.url)
    },
    check() {

    }
  },
  mounted() {
    this.initData();
  }
};
</script>
<style scoped>
.remark-a {
  margin: 0 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/bank/bank-info-supplement.vue